import React, { Component, Fragment } from 'react'
import CSSModules from 'react-css-modules'
import styles from '../styles.scss'
import { Box, Flex } from 'reflexbox'

class ErrorPage extends Component {
  errorRender = () => {
    return (
      <Flex
        align='center'
        column
        auto
        styleName='flexContainer'
      >
        <p>
          Error with the following projects
        </p>
        {
          this.props.errors.split(',').map((error, idx) => {
            return <p key={idx}>{error}</p>
          })
        }
        {/* <p> */}
          {/* {this.props.errors} */}
        {/* </p> */}
        <Box auto />
      </Flex>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.errorRender()}
      </React.Fragment>
    )
  }
}

export default CSSModules(ErrorPage, styles)
